import angular from 'angular';

angular.module('app.core').factory('Cooperative', Cooperative);

export default class Cooperative {

    constructor(cooperative, $translate) {
        this.translate = $translate;
        this.id = cooperative.id;
        this.name = cooperative.name;
        this.code = cooperative.code;
        this.email = cooperative.email;
        this.status = cooperative.status;
        this.communityDto = cooperative.communityDto;
    }

    getStatusLabel() {
        if (this.status) {
            return this.translate.instant('community.groupement.' + angular.lowercase(this.status));
        }
        return '';
    }
}
